module.exports = "/images/ws.svg?4e033e5684c36028586b02a01a04f037";